import axios from 'axios';
import { api } from '../config';

// Set baseURL global
axios.defaults.baseURL = api.API_URL;
axios.defaults.headers.post['Content-Type'] = 'application/json';
export const setAuthorization = token => {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};

class APIClient {
  get = (url, params) => {
    const query =
      params && Object.keys(params).length
        ? '?' +
          Object.entries(params)
            .map(([key, val]) => `${key}=${val}`)
            .join('&')
        : '';
    return axios.get(`${url}${query}`);
  };

  create = (url, data) => axios.post(url, data);
  update = (url, data) => axios.patch(url, data);
  put = (url, data) => axios.put(url, data);
  delete = (url, config = {}) => axios.delete(url, { ...config });
}

export default APIClient;
